import SignaturePad from "signature_pad";

/** The signature query is typed as paginated but returns the signature record itself. */
export const getSavedSignature = (data: unknown): string | undefined =>
  typeof data === "object" &&
  data !== null &&
  "providerSignature" in data &&
  typeof data.providerSignature === "string" &&
  data.providerSignature
    ? data.providerSignature
    : undefined;

/** Draws a signature image inside the pad keeping its aspect ratio. */
export const drawSignatureFitted = async (
  signPad: SignaturePad,
  canvas: HTMLCanvasElement,
  dataUrl: string
): Promise<void> => {
  const image = new Image();
  image.src = dataUrl;
  await image.decode();

  const scale = Math.min(
    canvas.width / image.width,
    canvas.height / image.height
  );
  signPad.clear();
  await signPad.fromDataURL(dataUrl, {
    ratio: 1,
    width: image.width * scale,
    height: image.height * scale,
    xOffset: (canvas.width - image.width * scale) / 2,
    yOffset: (canvas.height - image.height * scale) / 2,
  });
};
